<template>
	<div v-if="chartOptions.series[0].data[0].name != ''" id="test2" :options="chartOptions" @click="onClickBuble">
    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card>
        <v-card-title class="text-h6 font-weight-medium align-center justify-center">
          Page loading
        </v-card-title>
        <v-card-text class="body-1 align-center justify-center">
          Loading content, please wait
        </v-card-text>
        <v-card-title class="align-center justify-center">
          <v-progress-circular
            :size="70"
            :width="7"
            color="#0471A5"
            indeterminate
          ></v-progress-circular>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#0471A5" text @click="dialog = false">
            cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
  <div v-else id="test2" :options="chartOptions" @click="onClickBuble">
    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card>
        <v-card-title class="text-h6 font-weight-medium align-center justify-center">
          Page loading
        </v-card-title>
        <v-card-text class="body-1 align-center justify-center">
          Loading content, please wait
        </v-card-text>
        <v-card-title class="align-center justify-center">
          <v-progress-circular
            :size="70"
            :width="7"
            color="#0471A5"
            indeterminate
          ></v-progress-circular>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#0471A5" text @click="dialog = false">
            cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
	import HighCharts from 'highcharts';
  // import { decryptionData } from '@/components/utils/utils.js';
	import highchartsMore from 'highcharts/highcharts-more';
	highchartsMore(HighCharts);
  // import axios from "axios";
	export default {
    props: {
      selectedTopic: null,
      selectedPeriode: null,
      selectedTopic2: null,
      statusFilter: null,
      isClickBubleOrg: null,
      isClickWord: null,
      resetcolorClicked: null,
      updateSocket: null
    },
		data() {
			return {
        isClickBuble: "",
        colorClicked: "",
				id: 'test2',
        dialog: false,
        kontenBerita: [],
        mediaBerita: [],
        MediatwitterShare: [],
        MediaYtShare: [],
        topic2: [],
        SetPerson: [],
        chart_data_sort: [],

        pageplay: 100,

				chartOptions: {
					chart: {
						type: 'packedbubble',
						height: '309px'
					},
					title: {
            text: null
          },
					tooltip: {
						enabled: false
					},
					legend: {
						enabled: false
					},
					credits: {
						enabled: false
					},
          series: [
            {
              data: [{
                value: 0,
                name: ''
              }]
            },
          ],

          plotOptions: {
            packedbubble: {
              minSize: '40%',
              maxSize: '120%',
              zMin: 0,
              zMax: 1000,
              layoutAlgorithm: {
                splitSeries: false,
                gravitationalConstant: 0.02
              },
              dataLabels: {
                enabled: true,
                format: '{point.name}',
                useHTML: true,
                style: {
                  textAlign: 'center',
                  textOverflow: 'clip',
                  width: 100,
                  color: 'black',
                  textOutline: 'none',
                  fontWeight: 'normal'
                },
              }
            }
          },
				},
			}
		},
		mounted() {
      HighCharts.chart(this.id, this.chartOptions);
    },
		updated() {
			HighCharts.chart(this.id, this.chartOptions);
		},
    methods: {
      onClickBuble(event) {
        this.isClickBuble = event.point.name;
        console.log(event.point.color);
        this.colorClicked = event.point.color;
        this.$emit('bubble-clicked', this.isClickBuble); 
      },
      async loadKontenBerita() {
      // alert('aaa')
        this.mediaBerita = [];
        this.MediatwitterShare = [];
        this.MediaYtShare = [];
        HighCharts.chart(this.id, this.chartOptions);
        if (this.updateSocket == false) {
          this.dialog = true;
        }
        try {
          const data = this.$store.bubble_data;
          const person = [];
          const person2 = [];
          data.data_bubble.forEach((element) => {
            if (element["name"] != '' && element["name"] != null) {
              person.push(element["name"]);
              person2.push(element["name"]);
            }
          });

          this.SetPerson = [...new Set(person)];
          this.chart_data_sort = [];
          for (let x = 0; x < this.SetPerson.length; x++) {
            this.chart_data_sort.push({
              'name_person' : this.SetPerson[x],
              'name_person_value' : data.data_bubble[x].totalNews
            })
          }
          this.chart_data_sort.sort(function(a,b) { // sort desc value
            return (b.name_person_value) - (a.name_person_value);
          });
          const maxValue = Math.max(...this.chart_data_sort.map(item => item.name_person_value), 1);
          // Inisialisasi 6 series kosong
          this.chartOptions.series = Array.from({ length: 10 }, () => ({
            data: [{ value: 0, name: '' }]
          }));

          if (this.SetPerson.length === 0) {
            // Tidak ada data, biarkan kosong semua
            for (let i = 0; i < 10; i++) {
              this.chartOptions.series[i].data[0].name = '';
              this.chartOptions.series[i].data[0].value = 0;
            }
          } else {
            // Isi bubble maksimal 6 data
            for (let x = 0; x < Math.min(this.chart_data_sort.length, 10); x++) {
                const item = this.chart_data_sort[x];
              if(x === 0){
                this.chartOptions.series[x].data[0].name = item.name_person;
                const  percentValue = (item.name_person_value / maxValue) * 800;
                const adjustedValue = Math.max(Math.round(percentValue), 0);
                this.chartOptions.series[x].data[0].value = adjustedValue;
              }else{
                
                this.chartOptions.series[x].data[0].name = item.name_person;
                const before = this.chart_data_sort[x-1];
                const max =before.name_person_value;
                const  persen = (item.name_person_value / maxValue) * 100;
                const  percentValue = (item.name_person_value / max) * 500;
                const adjustedValue = Math.max(Math.round(percentValue-persen), 0);
                this.chartOptions.series[x].data[0].value = adjustedValue;

              }

            }
          }

          this.chartOptions.series = this.chartOptions.series.filter(
            seriesItem => seriesItem.data[0].name !== ""
          );
          this.dialog = false;
        } catch(e) {
          this.dialog = true;
          console.log('error');
          console.log(e);
        }
      },
    },
	};
</script>